import * as fromDatatype from '../datatype-library/index';
import {CouponGenerateConfig, CouponTreatmentJsonDatatypeInterface} from './bl_fi_mst_coupon_hdr';

export interface bl_fi_my_einvoice_batch_pool_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  running_no: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  run_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  run_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_my_einvoice_batch_pool_event_RowClass
  implements bl_fi_my_einvoice_batch_pool_event_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    run_type: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    duration_day: fromDatatype.IntegerDatatypeInterface;
    group_guid_01: fromDatatype.GuidDataFieldInterface;
    group_guid_02: fromDatatype.GuidDataFieldInterface;
    recurring_event_params: fromDatatype.VarcharDatatypeInterface;
    rrule: fromDatatype.VarcharDatatypeInterface;
    is_recurring: boolean;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: any;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    run_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
